/**
 * List of regions with their respective country codes and labels.
 *
 * @constant {Array<Object>} REGION_LIST
 * @property {string} country - The country code.
 * @property {string} label - The label for the country.
 */
export const REGION_LIST = [
  {
    country: 'ng',
    label: 'Nigeria',
    tokenStart: '2'
  },
  {
    country: 'gh',
    label: 'Ghana',
    tokenStart: '3'
  },
  {
    country: 'ug',
    label: 'Uganda',
    tokenStart: '4'
  },
  !!process.env.VUE_APP_ZM_ONLINE && {
    country: 'zm',
    label: 'Zambia',
    tokenStart: '5'
  }
].filter(Boolean)
